import React from "react";
import styles from "./filterWrapper/FilterWrapper.module.scss";
import FilterAddMore from "./FilterAddMore";
import SwitchKey from "../../../../Componnets/SwitchKey/SwitchKey";

const FilterWrapper = ({ title, children, isActive, isSelected, handleActiveFilter, handleAddFilter, disabled, themeColor }) => {

  const handleOnClick = (e, param) => {
    e.stopPropagation();
    handleAddFilter(param);
  }

  return (
    <div
      onClick={(e) => handleOnClick(e, "clickOnWrapper")}
      className={[styles.FilterWrapper, (isSelected ? styles.selected : ''), (disabled && styles.disabled)].join(' ')}
      style={{borderColor: isSelected && themeColor && themeColor}}
    >
      <div className={'d-flex flex-wrap align-items-center justify-content-between'}>
        <div className={styles.title}>{ title }</div>
            {(children && children.length !== 0) ? (
                <SwitchKey
                  handleOnChange={handleActiveFilter}
                  active={isActive}
                />
              ) : (
                <div>
                  <svg className={'d-flex flex-end'} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10 6.93933V13.0446" stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M13.0556 9.99203H6.94446" stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M13.9048 1.66663H6.09526C3.37304 1.66663 1.66669 3.59336 1.66669 6.32092V13.679C1.66669 16.4066 3.3651 18.3333 6.09526 18.3333H13.9048C16.6349 18.3333 18.3334 16.4066 18.3334 13.679V6.32092C18.3334 3.59336 16.6349 1.66663 13.9048 1.66663Z" stroke={themeColor ? themeColor : "#8A0FFF"} stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
              )
            }
      </div>
      {
        (children && children.length !== 0) && (
          <div className={'mt-2'}>
            { children }
            <FilterAddMore
              handleOnClick={(e) => handleOnClick(e, "addMore")}
            />
          </div>
        )
      }
    </div>
  )
};

export default FilterWrapper;